import { __decorate, __param } from '../../../../../node_modules/tslib/tslib.es6.js';
import { createDecorator } from 'monaco-editor/esm/vs/platform/instantiation/common/instantiation.js';
import { Emitter } from 'monaco-editor/esm/vs/base/common/event.js';
import { IExtHostRpcService } from './extHostRpcService.js';
const IExtHostTunnelService = ( createDecorator('IExtHostTunnelService'));
let ExtHostTunnelService = class ExtHostTunnelService {
    constructor(extHostRpc) {
        this.onDidChangeTunnels = (( new Emitter())).event;
    }
    async $applyCandidateFilter(candidates) {
        return candidates;
    }
    async openTunnel(extension, forward) {
        return undefined;
    }
    async getTunnels() {
        return [];
    }
    async setTunnelFactory(provider) {
        return { dispose: () => { } };
    }
    registerPortsAttributesProvider(portSelector, provider) {
        return { dispose: () => { } };
    }
    async $providePortAttributes(handles, ports, pid, commandline, cancellationToken) {
        return [];
    }
    async $forwardPort(tunnelOptions, tunnelCreationOptions) { return undefined; }
    async $closeTunnel(remote) { }
    async $onDidTunnelsChange() { }
    async $registerCandidateFinder() { }
};
ExtHostTunnelService = ( __decorate([
    ( __param(0, IExtHostRpcService))
], ExtHostTunnelService));
export { ExtHostTunnelService, IExtHostTunnelService };
